/**
 * Product Fruits tours navigate to the page URLs configured in the
 * Product Fruits console. Those are always standard-view paths, so a tour
 * step would silently kick master users out of the master view (e.g.
 * /master/content-creator/:id -> /content-creator). If the user is in the
 * master view and the target route has a master variant (named
 * `master-<name>`), rewrite the location to that variant.
 *
 * @param {import('vue-router').Router} router
 * @param {import('vue-router').RouteLocationNormalized} currentRoute
 * @param {string} location - in-app path requested by Product Fruits
 * @returns {string} the location to navigate to
 */
export function masterAwareLocation(router, currentRoute, location) {
  const isMasterView = currentRoute.path === '/master' || currentRoute.path.startsWith('/master/')
  if (!isMasterView) return location

  try {
    const target = router.resolve(location)
    if (!target.name || String(target.name).startsWith('master-')) return location

    const masterRouteName = `master-${String(target.name)}`
    if (!router.hasRoute(masterRouteName)) return location

    return router.resolve({
      name: masterRouteName,
      params: { ...currentRoute.params, ...target.params },
      query: target.query,
      hash: target.hash,
    }).fullPath
  } catch {
    // e.g. the master variant requires params we cannot provide —
    // fall back to the original Product Fruits location
    return location
  }
}
